import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'custom-container',
  templateUrl: './custom-container.wrapper.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CustomContainerWrapper extends FieldWrapper {
  showToolTip: boolean = false;

  handleToolTipClick() {
    this.showToolTip = !this.showToolTip;
  }
}
